import React from 'react';
import { getAIFeedbackData } from '../data/learningCycleData';

const AIFeedbackPage = ({ language = 'traditional', onBack, onKeepGoing }) => {
  const feedbackData = getAIFeedbackData();

  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-white">
            ←
          </button>
          <h1 className="text-xl font-bold">
            {getText(feedbackData.title)}
          </h1>
          <div className="w-8"></div> {/* Spacer for centering */}
        </div>

        {/* Main Title and Description */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold mb-3">
            {getText(feedbackData.subtitle)}
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed">
            {getText(feedbackData.description)}
          </p>
        </div>

        {/* Processing Card */}
        <div className="bg-white rounded-xl p-6 mb-4">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
              <div className="text-blue-600 text-2xl">🌐</div>
            </div>
            <p className="text-gray-800 font-medium">
              {getText(feedbackData.processingMessage)}
            </p>
          </div>
        </div>

        {/* Assessment Summary Card */}
        <div className="bg-white rounded-xl p-6 mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">
            {getText(feedbackData.assessmentSummary.title)}
          </h3>
          
          <p className="text-gray-700 text-sm mb-4">
            {getText(feedbackData.assessmentSummary.overallFeedback)}
          </p>

          {/* Pronunciation Feedback */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <div className="text-blue-600 text-sm">🎤</div>
              </div>
              <span className="text-gray-800 text-sm">
                {getText(feedbackData.assessmentSummary.pronunciation)}
              </span>
            </div>
            <div className="text-purple-600 text-sm">✈️</div>
          </div>

          {/* Vocabulary Feedback */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                <div className="text-orange-600 text-sm font-bold">E</div>
              </div>
              <span className="text-gray-800 text-sm">
                {getText(feedbackData.assessmentSummary.vocabulary)}
              </span>
            </div>
            <div className="text-red-600 text-sm">🚗</div>
          </div>

          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors">
            {getText({ traditional: 'View Full Assessment', simplified: 'View Full Assessment', english: 'View Full Assessment' })}
          </button>
        </div>

        {/* Keep Going Button */}
        <button
          onClick={onKeepGoing}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors mb-8"
        >
          {getText({ traditional: 'Keep Going', simplified: 'Keep Going', english: 'Keep Going' })}
        </button>

        {/* Navigation Arrows */}
        <div className="flex justify-between items-center mb-6">
          <button className="text-white text-xl">←</button>
          <button className="text-white text-xl">→</button>
        </div>

        {/* AI Coach Section */}
        <div className="mb-6">
          <h3 className="text-lg font-bold mb-3">
            {getText(feedbackData.aiCoachSection.title)}
          </h3>
          <p className="text-gray-300 text-sm leading-relaxed">
            {getText(feedbackData.aiCoachSection.description)}
          </p>
        </div>

        {/* Speech Recognition Section */}
        <div className="mb-20">
          <h3 className="text-lg font-bold mb-3">
            {getText(feedbackData.speechRecognitionSection.title)}
          </h3>
          <p className="text-gray-300 text-sm leading-relaxed">
            {getText(feedbackData.speechRecognitionSection.description)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIFeedbackPage;
